export default __webpack_public_path__ + "static/media/landing-lg.85136361.jpg";